export default "__VITE_ASSET__1c06675d__"